import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProfileService } from '../services/profile.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.page.html',
  styleUrls: ['./password.page.scss'],
})
export class PasswordPage implements OnInit {

  password: string;
  newPassword = "";
  retypePassword = "";
  email: string;
  constructor(private modalCtrl: ModalController,
    private profileService: ProfileService) {
    this.password = "";
    this.email = "";
    console.log(this.email)
  }

  ngOnInit() {
    this.getPasswort();
  }

  getPasswort() {
    //this.password = this.profileService.getCurrentUser.password();
    this.password = "test123";
  }

  cancelChangePassword() {
    this.modalCtrl.dismiss();
  }

  // saveNewPassword() {
  //   // do save password
  //   // this.profileService.updatePassword("test1234", "test123");
  //   this.modalCtrl.dismiss();
  // }

  saveNewPassword() {
    if (this.newPassword !== this.retypePassword) {
      alert('New Password and Retype Password do not match!');
      return;
    }

    this.profileService.updatePasswordNew(this.newPassword);
  
    // this.profileService.updatePassword(this.newPassword, this.password, this.email).then(() => {
    //   alert('Password successfully changed!');
    //   this.modalCtrl.dismiss();
    // }).catch((error) => {
    //   alert(`Error changing password: ${error}`);
    // });
  }

}
